// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"228b77fe","847":"6df31d94"}[chunkId] + ".chunk.css";
};